import Modal from 'libs/components/modal';

export default {
  methods: {
    launchUpgradeOverlay() {
      Modal.for('mobile-overlay', {
        title: 'Membership changes are not yet available from the mobile app',
        btnText: 'Got It'
      })
    }
  },
};
